import React, { Component } from "react";
import { Link } from "react-router-dom";
// styles for page
import "./authentication.css";
// images for page
import Logo from "../assets/images/logo.png";
import LeftPartBg from "../assets/images/register/80a8f0b0-ef84-4333-b37c-214d0a55f9a6.png";
// import call module
import axios from "axios";

export default class confirmEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlValid: null,
      token: null
    };
  }
  componentDidMount = () => {
    // initializze
    let url = window.location.pathname;
    let token = url.slice(url.lastIndexOf("/") + 1, url.length);
  };
  checkMailDoubleValid = () => {
    let url = window.location.pathname;
    let token = url.slice(url.lastIndexOf("/") + 1, url.length);
    axios
      .post(`${window.urlPath}/auth/confirm`, {}, { headers: { token: token } })
      .then(res => {
        if (!res.data.code) {
          this.setState({
            urlValid: false
          });
        }
      });
  };
  checkUser = code => {
    if (code) {
      this.setState(
        {
          urlValid: true
        },
        this.checkMailDoubleValid()
      );
    } else {
      this.setState({
        urlValid: false
      });
    }
  };
  render() {
    const confirmEmail = (
      <div>
        <form>
          <img src={Logo} />
          <div className="formHeading">You Email Confirmed</div>
          <label className="centered grayTxt">
            Go to &nbsp; <Link to="/login">Login page</Link>
          </label>
        </form>
      </div>
    );
    const page404 = <h1>Page not found</h1>;
    return (
      <div className="authPage">
        <div className="leftPart grayBg">
          <img src={LeftPartBg} />
        </div>
        <div className="rightPart">
          {this.state.urlValid ? confirmEmail : page404}
        </div>
      </div>
    );
  }
}
